/**
 * A mapping between font size tokens and their associated spacing tokens. This ensures a uniform
 * gap between elements based on their font size. Using a font size token to derive a gap allows
 * both inline and block elements to have consistent spacing.
 */ const fontSizeToGap = {
    '2xs': '2xs',
    xs: '2xs',
    sm: 'xs',
    md: 'xs',
    lg: 'sm',
    xl: 'sm',
    '2xl': 'md',
    '3xl': 'md',
    '4xl': 'lg',
    '5xl': 'lg',
    '6xl': 'xl',
    '7xl': 'xl'
};

export { fontSizeToGap };
//# sourceMappingURL=font-size-to-gap.js.map
